import React, {useEffect} from "react";

const AdsenseTermsDialog = ({close}) => {
  const handleClickOutside = (ev) => {
    if (ev.target === ev.currentTarget) {
      close();
    }
  };
  useEffect(() => {
    document.body.className = "scroll_hide";
    return () => {
      document.body.className = "";
    }
  }, []);

  return (
    <div className="container_layer"  onClick={handleClickOutside}>
      <div className="blog_layer"
           style={{top: 'calc(50% - 244px)'}}>
        <div className="inner_blog_layer inner_blog_layer7">
          <div className="cont_layer">
            <strong className="tit_popup">AdSense 연동 안내</strong>
            <ul className="list_cont_layer">
              <li>
                <em className="tit_list">1. AFP 참가</em>
                <span className="txt_popup_type1">티스토리에서 구글 애드센스 계정을 연동해 광고를 설정하고 통계, 수익을 확인하는 것은 구글의 ‘AdSense For Platforms”에 참여하고, 구글 애드센스 정책을 준수해야 함을 의미합니다.</span>
              </li>
              <li>
                <em className="tit_list">2. AFP란?</em>
                <span className="txt_popup_type1">구글에서 티스토리와 같은 콘텐츠 플랫폼에 제공하는 솔루션으로, “원활한 광고 설정 및 쉬운 수익 지급을 통해 사용자에게 편의를 제공하고, 수익을 공유할 수 있는 기능”입니다. AFP를 통해 발생한 수익은 플랫폼(티스토리)에서 정한 비율에 따라 공유됩니다. 티스토리에는 비율을 “0%”로 설정합니다. </span>
              </li>
              <li>
                <em className="tit_list">3. 연동 해제</em>
                <span className="txt_popup_type1">연동을 해제하는 것은 AFP에 더이상 참여하지 않음을 의미하며, 티스토리에서 광고를 설정하고, 통계 및 수익을 확인하는 기능을 사용하는 것이 불가능합니다.</span>
              </li>
            </ul>
          </div>
          <div className="fld_btn">
            <button type="submit" className="btn_default" onClick={close}>확인</button>
          </div>
          <label className="lab_btn" onClick={close}>
            <span className="ico_blog">레이어 닫기</span>
            <input type="button" className="btn_g" value="닫기"/>
          </label>
        </div>
      </div>
    </div>
  )
};

export default AdsenseTermsDialog;